define('CTI.CreditApplication.CreditApplicationModule', [
    'CreditApplication.View',
    'Backbone'
], function (
    CreditApplicationView,
    Backbone
) {
    'use strict';

    var CreditApplicationRouter = Backbone.Router.extend({
        routes: {
            'Terms-Application': 'showCreditApp',
            'terms-application': 'showCreditApp',
            'credit-application': 'showCreditApp',
            'Credit-Application': 'showCreditApp'
        },
        initialize: function (application) {
            this.application = application;
        },
        showCreditApp: function () {
            var view = new CreditApplicationView({
                application: this.application
            });
            view.showContent();
        }
    });

    return {
        mountToApp: function mountToApp(container) {
            var pageType = container.getComponent('PageType');

            if (pageType) {
                pageType.registerPageType({
                    name: 'CreditApplicationPage',
                    routes: [
                        'Terms-Application',
                        'terms-application',
                        'credit-application',
                        'Credit-Application'
                    ],
                    view: CreditApplicationView,
                    defaultTemplate: {
                        name: 'cti_credit_application_form.tpl',
                        displayName: 'Credit Application Default'
                    }
                });
            }

            // Initialize Backbone Router for direct URL access in local testing and production
            return new CreditApplicationRouter(container);
        }
    };
});

